// Static Images
import { AlertModal, FormElems } from 'components';
import { ERROR_MESSAGES } from 'utils/constants/toastMessages';
import DownloadIcon from '../../static/images/downloadIcon.png';
import downArrowImg from '../../static/images/down-arrow.png';

import DownloadPreFilledFileFilter from './DownloadPreFilledFileFilter';
import { uploadBulkPaymentLinkFileRequest } from './redux/BulkPaymentLink.actions';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

const BulkPaymentLinkHeader = ({ actions, bulkPaymentLinkData }) => {
    const [showPopUp, setShowPopUp] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isShowModal, setIsShowModal] = useState(false);

    const togglePopUp = () => {
        setShowPopUp(!showPopUp);
    };

    const onSuccessModal = () => {
        const formData = new FormData();
        formData.append('inputFile', selectedFile);
        actions.uploadBulkPaymentLinkFileRequest(formData);
        setIsShowModal(false);
    };

    const handleFileChange = (value, event) => {
        event.preventDefault();
        const files = event.target.files[0];
        if (files && /.+(\.csv)$/.test(files.name)) {
            setSelectedFile(files);
            setIsShowModal(true);
        } else {
            toast.info(ERROR_MESSAGES.ONLY_CSV_FILE);
        }
    };

    return (
        <div className="bulk-payment-link-wrapper-header">
            <h3 className="page-tile">Bulk Payment Link</h3>
            <div className="bulk-payment-link-wrapper-actions">
                <ul className="download-actions">
                    <li className="download-prefilled-container">
                        <FilterPopupUp
                            showPopUp={showPopUp}
                            togglePopUp={togglePopUp}
                            customComponent={<DownloadPreFilledFileFilter />}
                        >
                            <div
                                onClick={togglePopUp}
                                className="download-prefilled-customClass"
                            >
                                <img
                                    src={DownloadIcon}
                                    alt="Download"
                                    className="download-icon"
                                />
                                <div className="action-text">
                                    <div className="action-text-left">
                                        <p>Generate and Download Sample File</p>
                                    </div>
                                    <img
                                        src={downArrowImg}
                                        alt="downArrow"
                                        className={`action-text-right ${
                                            showPopUp ? 'rotate' : ''
                                        }`}
                                    />
                                </div>
                            </div>
                        </FilterPopupUp>
                    </li>
                    <li>
                        <label htmlFor="UploadBinFile" className="file-label">
                            <img
                                src={DownloadIcon}
                                alt="Download"
                                className="download-icon"
                            />
                            <div className="action-text">
                                <p>Upload File</p>
                            </div>
                        </label>
                        <form encType="multipart/form-data" action="">
                            <FormElems.Input
                                name="uploadFile"
                                type="file"
                                id="UploadBinFile"
                                wrapperClass="fileInput"
                                defaultValue="fileName"
                                input="true"
                                accept=".csv"
                                handleChange={handleFileChange}
                            />
                        </form>
                    </li>
                </ul>
            </div>
            <AlertModal
                modalIsOpen={isShowModal}
                closeModal={() => setIsShowModal(false)}
                primaryButtonText="OK"
                secondaryButtonText="CANCEL"
                showActions={true}
                headerText={'Confirmation'}
                onSuccessModal={onSuccessModal}
                message={`Are you sure you want to upload ${selectedFile?.name}?`}
            />
        </div>
    );
};

const FilterPopupUp = ({ showPopUp, children, customComponent }) => {
    return (
        <>
            <div className="filterPopupUp-container">
                {children}
                {showPopUp ? customComponent : null}
            </div>
        </>
    );
};

FilterPopupUp.propTypes = {
    showPopUp: PropTypes.bool,
    children: PropTypes.node,
    customComponent: PropTypes.node,
    togglePopUp: PropTypes.func,
};

BulkPaymentLinkHeader.propTypes = {
    actions: PropTypes.object,
    bulkPaymentLinkData: PropTypes.object,
};

const mapStateToProps = ({ bulkPaymentLinkData }) => ({
    bulkPaymentLinkData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            uploadBulkPaymentLinkFileRequest,
        },
        dispatch
    ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BulkPaymentLinkHeader);
